<script setup lang="ts">
import { toast } from '@/shared/toast'
import DarwinButton from '@/uiKit/DarwinButton.vue'
import { ref } from 'vue'

const props = defineProps<{
  url: string
  labelId: string
}>()

/**
 * Text to render on the copy link button. The text changes to 'Copied' for a short
 * time after the link is copied to the clipboard.
 */
const copyButtonText = ref<'Copy link' | 'Copied'>('Copy link')

/** Copy a link to the current agent to the clipboard */
const onCopyLink = ({ showToast }: { showToast: boolean }) => {
  navigator.clipboard.writeText(`${window.location.protocol}//${props.url}`)

  if (showToast) {
    toast.success('Link copied to clipboard')
  }

  copyButtonText.value = 'Copied'
  setTimeout(() => {
    copyButtonText.value = 'Copy link'
  }, 2000)
}
</script>

<template>
  <div class="flex w-full max-w-full flex-row justify-between gap-6 px-4">
    <div class="flex shrink grow-0 flex-col overflow-hidden">
      <p
        :id="labelId"
        class="cursor-pointer text-md-13px-default text-text"
        @click="onCopyLink({ showToast: true })"
      >
        Share this agent
      </p>
      <span
        class="shrink grow-0 cursor-pointer truncate text-xs-11px-light text-text-subtlest"
        @click="onCopyLink({ showToast: true })"
      >
        {{ url }}
      </span>
    </div>
    <DarwinButton
      rounded
      variant="outline"
      class="w-[88px] max-w-[88px] shrink-0"
      size="md"
      @click="onCopyLink({ showToast: false })"
    >
      {{ copyButtonText }}
    </DarwinButton>
  </div>
</template>
